module.exports = __webpack_public_path__ + "img/junk.b966773c.svg";